import { ICasePartial } from '../../../../app/entities/Case'

enum CASE_STATUS {
  OPEN = 'open',
  CLOSED = 'closed',
  IN_PROGRESS = 'in_progress',
  OVERDUE = 'overdue',
}

enum INVESTIGATION_STATUS {
  UNDER_INVESTIGATION = 'under_investigation',
  COMPLETED = 'completed',
}

const INITIAL_CASE_DATA: ICasePartial = {
  caseStatus: CASE_STATUS.OPEN,
  caseHistory: [],
  damageCost: 0,
  isRoadie: false,
  isRiskConnect: false,
  isTechnicianFault: false,
  note: '',
  riskConnectCaseNumber: '',
  riskScore: 0,
  summary: '',
  type: '',
}

export { INITIAL_CASE_DATA, CASE_STATUS, INVESTIGATION_STATUS }
